import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Button } from "reactstrap";
import msparcs from "assets/img/msparcs.png";
import { isMobile } from "react-device-detect";
import "../ipos/css/TotalEMI.css";
import TotalEMI from "../assets/img/welcomepage/totalemi.png";
import BrandEMI from "../assets/img/welcomepage/brandemi.png";
import Unipay from "../assets/img/welcomepage/unipay.png";

import TotalEMIIcon from "../assets/img/welcomepage/totalemiicon.png";
import BrandEMIIcon from "../assets/img/welcomepage/brandemiicon.png";
import UnipayIcon from "../assets/img/welcomepage/unipayicon.png";
import {connect}  from  "react-redux";
let menuList='';
class MobWelcomeMenu extends Component {
  state = {
    data: [],
    chartHeight: "250px",
    web: true,
    mob: false,
    topmenus: false,
    totalemi: false,
    brandemi: false,
    unipay: false,
  };

  componentWillMount() {
 this.props.currentMenu("home");
    this.checkdevice();
  }

  checkdevice = () => {
 //   console.log("Name is:"+JSON.stringify(this.props.reducerState.menuList.length));
     menuList = JSON.parse(localStorage.getItem("MenuList"));
    if (menuList.length >1 ) {
     menuList.map((data,index) =>{
      if (data.includes("totalemi")) {
        this.setState({ totalemi: true });
      }
      if (data.includes("brandemi")) {
        this.setState({ brandemi: true });
      }
      if (data.includes("unipaynext")) {
        this.setState({ unipay: true });
      }
      })
    }
    else {
      this.setState({ topmenus: false });
    }
  };
    
  render() {
   if (menuList.length ==1 ) {
      return <Redirect to="/admin/welcomepage" />;
    }
    return (
      <div className="content">
        <div className="container-fluid space-container-fluid">
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <div className="col-md-12 col-xs-12 p-0">
                <div className="card p-10" style={{ height: "600px" }}>
                  <div
                    className="header text-center"
                    style={{ paddingBottom: "0px" }}
                  >
                    <h4
                      className="title"
                      style={{
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        color: "#FA7626",
                        fontSize: "150%",
                      }}
                    >
                      <img
                        src={msparcs}
                        alt={msparcs}
                        className="mSpaceLogo"
                        width={"40%"}
                      />
                    </h4>
                    <h4 className="welcome-to-m-sparcs">Welcome To mSparcs</h4>
                    <p className="innovitis-analytics">
                      Innoviti’s Analytics Platform
                    </p>
                    {/* <div className="line-devider"></div> */}
                  </div>
                  <div className="line-devider"></div>
                  <div className="col-xs-12 text-center p-0">
                    <p className="please-select-a-prod">
                      Please select a product
                    </p>
                    {this.state.totalemi && (
                      <div className="item" onClick={() => {this.props.currentMenu("totalemi")}}>
                        <Link to="/admin/totalemi-dashboard">
                          <img src={TotalEMIIcon} className="menu" />
                          <span className="img-text">Total EMI</span>
                        </Link>
                      </div>
                    )}
                 {/*
                  {this.state.brandemi && (
                      <div className="item" onClick={() => {this.props.currentMenu("brandemi")}}>
                        <Link to="/admin/brand-dashboard">
                          <img src={BrandEMIIcon} className="menu" />
                          <span className="img-text">Brand EMI</span>
                        </Link>
                      </div>
                    )}

                    */}
                    {this.state.unipay && (
                      <div className="item" onClick={() => {this.props.currentMenu("unipaynext")}}>
                       <Link to="/admin/dashboard">
                          <img src={UnipayIcon} className="menu" />
                          <span className="img-text">UnipayNext</span>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return { reducerState: state }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(MobWelcomeMenu);
